import * as React from 'react';
import { Modal } from '@app/src/components/Modal';
import { FrameWrapper, FrameContent } from './styled';
import { useHistory } from 'react-router-dom';

export const Container = ({
  openModal,
  closeModal,
  reset
}) => {

  const history = useHistory();
  const handleCloseModal = () => {
    closeModal();
    reset();
    history.push('/');
  };
  return(
    <Modal
        openModal={openModal}
        closeModal={handleCloseModal}
      >
      <FrameWrapper>
        <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M45.8337 23.0834V25C45.8311 29.4926 44.3764 33.8639 41.6864 37.4622C38.9965 41.0604 35.2155 43.6927 30.9073 44.9665C26.5991 46.2403 21.9946 46.0873 17.7805 44.5304C13.5663 42.9735 9.96836 40.0961 7.52316 36.3273C5.07796 32.5584 3.91656 28.1002 4.21215 23.6174C4.50775 19.1346 6.24451 14.8674 9.16341 11.4523C12.0823 8.03717 16.027 5.65709 20.4091 4.66701C24.7911 3.67694 29.3759 4.12991 33.4795 5.95838" stroke="#4EC853" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M45.8333 8.33337L25 29.1875L18.75 22.9375" stroke="#4EC853" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
        <FrameContent>
          Recibirá un correo electrónico para restablecer su contraseña siempre y cuando su dirección esté registrada.
        </FrameContent>
      </FrameWrapper>
    </Modal>
  );
};
